module.exports = {
  "checkbox": {
    "width": "36",
    "height": "36"
  },
  "avatar": {
    "width": "96",
    "height": "96",
    "marginLeft": "32",
    "backgroundColor": "#f8f8f8",
    "borderRadius": "48",
    "overflow": "hidden"
  },
  "item-img": {
    "width": "96",
    "height": "96"
  },
  "dof-cell": {
    "position": "relative",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "paddingLeft": "32"
  },
  "checkBox-top-border": {
    "borderBottomColor": "#dddddd",
    "borderBottomWidth": "1"
  },
  "checkBox-bottom-border": {
    "borderBottomColor": "#dddddd",
    "borderBottomWidth": "1"
  },
  "fakeSubBorder": {
    "height": "1",
    "position": "absolute",
    "right": 0,
    "bottom": 0,
    "backgroundColor": "#dddddd",
    "left": "86"
  },
  "active-cell": {
    "backgroundColor:active": "#f5f5f5"
  },
  "main-wrapper": {
    "flex": 1,
    "flexDirection": "row",
    "alignItems": "center",
    "paddingRight": "32",
    "marginLeft": "24"
  },
  "content-title": {
    "flex": 1,
    "flexDirection": "column",
    "justifyContent": "flex-start"
  },
  "cell-title": {
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center",
    "flex": 1
  },
  "title-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "32",
    "color": "#1e2e37",
    "lines": 1,
    "textOverflow": "ellipsis",
    "overflow": "hidden"
  },
  "title-flex-expand": {
    "flex": 1
  },
  "cell-title-btn": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "24",
    "height": "48",
    "lineHeight": "48",
    "paddingLeft": "20",
    "paddingRight": "20",
    "borderRadius": "24",
    "marginLeft": "20",
    "color": "#616c73",
    "backgroundColor": "#f6f7f9",
    "maxWidth": "350",
    "overflow": "hidden",
    "textOverflow": "clip"
  },
  "sub-title": {
    "marginTop": "16"
  },
  "sub-text": {
    "fontFamily": "'PingFangSC-Regular'",
    "fontSize": "24",
    "color": "#8e969b",
    "lines": 1,
    "textOverflow": "ellipsis",
    "overflow": "hidden",
    "flex": 1
  },
  "cell-top-border": {
    "borderTopColor": "#dddddd",
    "borderTopWidth": "1"
  },
  "cell-bottom-border": {
    "borderBottomWidth": "1",
    "borderBottomStyle": "solid",
    "borderBottomColor": "#dddddd"
  },
  "cell-arrow-icon": {
    "width": "40",
    "height": "40"
  },
  "checkbox-disabled": {
    "opacity": 0.3
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5662659c!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-checkbox/index.vue
// module id = 475
// module chunks = 0 1